import { ReactNode } from 'react';

import {
  Stack,
  StackProps,
  Tooltip,
  TooltipProps,
  Typography,
  TypographyProps,
} from '@mui/material';

import { Icon, IconColor, IconSize } from '@/components/ui/Icon';

interface IconedLabelProps extends Omit<
  StackProps,
  'direction' | 'alignItems' | 'gap'
> {
  iconName: string;
  children: ReactNode;
  typographyProps?: TypographyProps;
  iconColor?: IconColor;
  iconSize?: IconSize;
  tooltip?: ReactNode;
  tooltipProps?: Omit<TooltipProps, 'title'>;
}
export const IconedLabel = ({
  iconName,
  children,
  typographyProps,
  iconColor,
  iconSize = 'medium',
  tooltip,
  tooltipProps,
  ...stackProps
}: IconedLabelProps) => {
  const content = (
    <Stack direction="row" alignItems="center" gap={0.5} {...stackProps}>
      <Icon name={iconName} color={iconColor} size={iconSize} />
      <Typography component="p" variant="label" {...typographyProps}>
        {children}
      </Typography>
    </Stack>
  );

  return tooltip ? (
    <Tooltip {...tooltipProps} title={tooltip}>
      {content}
    </Tooltip>
  ) : (
    content
  );
};
